import { getPersonas } from '@/services/personas';
import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Persona } from '@/types/personas';

interface AppState {
  isLoading: boolean;
  error: string | null;
  personas: Persona[];
  currentPersona: Persona | null;
}

const initialState: AppState = {
  isLoading: false,
  error: null,
  personas: [],
  currentPersona: null,
};

export const actionGetPersonas = createAsyncThunk('app/getPersonas', async () => {
  const response = await getPersonas();
  return response;
});

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setCurrentPersona: (state, action: PayloadAction<Persona>) => {
      state.currentPersona = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(actionGetPersonas.fulfilled, (state, action) => {
      const personasReturned = action.payload.personas;
      const personas: Persona[] = [];
      
      // Debug: log della struttura dei dati
      console.log('Personas data structure:', personasReturned);
      console.log('Aware type:', typeof personasReturned.aware, personasReturned.aware);
      console.log('NotAware type:', typeof personasReturned.unaware, personasReturned.unaware);
      
      // Protezione: verifica che aware e notAware siano array
      if (Array.isArray(personasReturned.aware)) {
        for (const persona of personasReturned.aware) {
          personas.push({
            id: persona.id,
            name: persona.name,
            aware: true
          });
        }
      }
      
      if (Array.isArray(personasReturned.unaware)) {
        for (const persona of personasReturned.unaware) {
          personas.push({
            id: persona.id,
            name: persona.name,
            aware: false
          });
        }
      }
      
      state.personas = personas;
      state.isLoading = false;
    });
    builder.addCase(actionGetPersonas.rejected, (state, action) => {
      state.error = action.error.message ?? 'Unknown error';
      state.isLoading = false;
    });
    builder.addCase(actionGetPersonas.pending, (state) => {
      state.isLoading = true;
    });
  },
});

export const { 
  clearError, 
  setCurrentPersona, 
} = appSlice.actions;

export default appSlice.reducer;